import { Grid, Layout } from "antd";
import { AppHeader } from "components/AppHeader/AppHeader";
import { AppLayout } from "components/AppLayout";
import { AppContent } from "components/AppLayout/AppContent";
import { AppSider } from "components/AppSider";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { fetchInitConfig } from "store/app/appSlice";
import { fetchDataForLoggedInUser } from "store/requisition/requisitionSlice";

const { useBreakpoint } = Grid;

export const LoggedInLayout = () => {
  const screen = useBreakpoint();
  const dispatch = useAppDispatch();
  const { whId, whDivId } = useAppSelector((state) => state.app);

  useEffect(() => {
    dispatch(fetchDataForLoggedInUser());
    dispatch(fetchInitConfig());
  }, [dispatch]);

  // Global platform config (wms-web) for the session — fetched once warehouse
  // & division are selected, and re-fetched whenever either changes.
  useEffect(() => {
    if (whId !== undefined && whDivId !== undefined) {
      dispatch(fetchInitConfig());
    }
  }, [dispatch, whId, whDivId]);

  return (
    <AppLayout>
      <AppHeader />
      <Layout>
        <AppSider></AppSider>
        <AppContent style={{ ...(screen.xs && { paddingBottom: "7rem" }) }}>
          <Outlet />
        </AppContent>
      </Layout>
    </AppLayout>
  );
};
